// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2000":"5cfa3d4b","2927":"93441025","3673":"05b18ff1","4075":"30482441","5070":"4c460736","9436":"289277f9","9671":"8902a5b4"}[chunkId] + ".chunk.css";
};